import nl from "./nl";
//import en_data from "./en"; // No translations yet

const data = {
  nl: nl,
  //en: en_data,
};

export default data;
